export const AUTENTICACAO_LOGAR = "AUTENTICACAO_LOGAR";
export const AUTENTICACAO_SAIR = "AUTENTICACAO_SAIR";
export const SET_PIPEDRIVE_DEAL_ID = "SET_PIPEDRIVE_DEAL_ID";
export const SET_ORCAMENTO_ID = "SET_ORCAMENTO_ID";
